/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const HealIcon = ({ width = 24, height = 24, hidden = false, title = 'Heal' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M32.728 3.272a6 6 0 0 0-8.485 0l-6.456 6.456L3.272 24.243a6 6 0 0 0 8.485 8.485l5.943-5.947 15.028-15.024a6 6 0 0 0 0-8.485ZM19 11a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm-6 10a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm4 4a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm6-6a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
    />
  </svg>`;
};
